// extracted by mini-css-extract-plugin
var _1 = "ErrorMessage_container__XVn0p";
export { _1 as "container" }
